import React, { useState } from "react";

import { FormButton } from "components";
import { FormikTextInput, FormikYesOrNoInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    rowSelected,
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import { FORM_ERROR_MESSAGES } from "consts/errorMessages";

import styles from "styles/pages/ModalActions.module.scss";
import { handleResponse } from "services/Local-services";
import { zonaIns } from "services/services-mia/miakey";
import { inputTextRegexp } from "utils/regexp";

export default function InsertModal({ updateList, closeModal }) {
    const setSelected = useSetRecoilState(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);

    const [inRequest, setInRequest] = useState(false);

    const handleSubmit = async ({
        nombre,
        cod,
        global,
    }) => {
        setInRequest(true);

        const response = await zonaIns({
            gateZonaNombre: nombre,
            gateZonaCod: cod,
            gateZonaGlobal: global ? "Y" : "N",
        }, credentials);

        const functions = {
            setSnackbarInfo,
            setIsOpen: closeModal,
            setSelected,
            updateList,
        };

        handleResponse(
            response,
            "Zona añadida exitosamente",
            functions
        );

        setInRequest(false);
    };

    return (
        <Formik
            initialValues={{
                nombre: '',
                cod: '',
                global: false,
            }}
            validationSchema={
                yup.object({
                    nombre: yup.string(FORM_ERROR_MESSAGES.text)
                        .max(80, "Debe tener un maximo de 80 caracteres")
                        .required(FORM_ERROR_MESSAGES.required),
                    cod: yup.string(FORM_ERROR_MESSAGES.text)
                        .max(15, "Debe tener un maximo de 15 caracteres")
                        .matches(
                            inputTextRegexp,
                            "Debe tener solo letras y/o números"
                        )
                        .required(FORM_ERROR_MESSAGES.required)
                })
            }
            onSubmit={(values, { setSubmitting }) => {
                try {
                    handleSubmit(values);
                } catch (e) {
                    setSnackbarInfo({
                        message: e.errmsg,
                        severity: "error",
                        open: true,
                    });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column-sm"]}>
                    <FormikTextInput
                        fullWidth={true}
                        name="cod"
                        labelText="Código"
                        placeholder="Ingrese código"
                    />
                    <FormikTextInput
                        fullWidth={true}
                        name="nombre"
                        labelText={"Nombre"}
                        placeholder={"Ingrese nombre"}
                    />
                    <FormikYesOrNoInput
                        name="global"
                        labelText="Global"
                    />
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Agregar" }}
                        onCloseModal={closeModal}
                    />
                </div>
            </Form>
        </Formik>
    );
}